<template>
  <div class="main text-left">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <router-link to="/console">创作者中心</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ this.$t('lang.toolbar.PasswordChange') }}</li>
      </ol>
    </nav>
    <label class="text-muted small">{{ this.$t('lang.words.newpassword') }}</label>
    <div class="form-floating mb-3">
      <input type="password" class="form-control" id="floatingPassword" v-model="input.password" :maxlength="50"
        :placeholder="this.$t('lang.dict.password')">
      <label for="floatingPassword">{{ this.$t('lang.dict.password') }}</label>
    </div>
    <div class="form-floating mb-3">
      <input type="password" class="form-control" id="floatingPassword2" v-model="input.password2" :maxlength="50"
        :placeholder="this.$t('lang.words.password2')">
      <label for="floatingPassword2">{{ this.$t('lang.words.password2') }}</label>
    </div>
    <span class="btn btn-info" v-on:click="ok()">{{ this.$t('lang.toolbar.OK') }}</span>
  </div>
</template>
<script>
import { Modal } from 'bootstrap'
import sx from '../../utils/core.js'

// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      input: {
        password: '',
        password2: ''
      }
    }
  },
  created() {
    this.$store.state.confirmdef = {
      title: this.$t('lang.toolbar.Confirm'),
      msg: this.$t('lang.msg.toContinue'),
      event: 'ChangePassword'
    }
  },
  methods: {
    ok() {
      const that = this
      if (that.input.password != '' || that.input.password2 != '') {
        if (that.input.password != that.input.password2) {
          sx.toastError(that.$t('lang.error.failedLogin'));
          return;
        }
        const myconfirmModal = new Modal(document.querySelector("#myModalConfirm"));
        myconfirmModal.show();
        $("#confirm").click(function () {
          myconfirmModal.hide();
          if (that.$store.state.confirmdef.event != "ChangePassword") {
            return;
          }
          const mymodal = sx.showWaiting()
          var items = {}
          var params = {
            password: that.input.password,
            items: JSON.stringify(items),
            keys: JSON.stringify({
              username: that.$store.state.userinfo.username
            }),
            token: localStorage.getItem('token')
          }
          sx.request(
            that.$store.state.baseurl + '/app/authhelper/changePassword',
            params,
            function (result) {
              if (result.status === 'ok') {
                sx.toastSuccess(result.message)
                localStorage.setItem('authenticated', false)
                localStorage.setItem('userinfo', '{}')
                that.$store.state.authenticated = false
                that.$router.replace({ name: 'Login' })
              } else {
                sx.toastError(that.$t('lang.error.failed', { str: that.$t('lang.words.newpassword') }))
              }
            },
            function (result) {
              sx.toastError(that.$t('lang.error.failed', { str: that.$t('lang.words.newpassword') }))
              console.log('password change failed', result)
            }
          )
          sx.hideWaiting(mymodal)
        })
      } else {
        sx.toastError(that.$t('lang.error.required', { str: that.$t('lang.dict.password') }));
        console.log('password must be present')
      }
    }
  }
}
</script>
